export default "__VITE_ASSET__5979c212__"